import React from 'react';
import { Link } from 'react-router-dom'
import Drawer from 'material-ui/Drawer';
import LinearProgress from 'material-ui/LinearProgress';
import MdHeadsetMic from 'react-icons/lib/md/headset-mic'
import MdNextWeek from 'react-icons/lib/md/next-week'
import MdInsertDriveFile from 'react-icons/lib/md/insert-drive-file'
import MdHelp from 'react-icons/lib/md/help'
import MdMenu from 'react-icons/lib/md/menu'
import TextField from 'material-ui/TextField';
import RaisedButton from 'material-ui/RaisedButton';
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import * as actions from '../../../Actions/company'; 
import { connect } from 'react-redux';
import {Row,Col} from 'react-bootstrap';
import Modal from 'react-modal';
import env from '../../../config/env.js'
import { Route, withRouter } from 'react-router-dom';
import MdDashboard from 'react-icons/lib/md/dashboard';
const apiUrl=env.apiUrl;
Modal.setAppElement('#root')

class SideBar extends React.Component{
	constructor(props) {
	    super(props);
	    this.state = {
	    	open: true,
	    	modalIsOpen: false,
	    	userNameReq: false,
	    	userMessageReq: false,
	    	userEmailReq: false,
	    	name: '',
	    	email: '',
	    	changeEmail: false,
	    	changeName: false,
	    	onLoadMobile: false,
	    	checkOnload: false,
	    	buttonDisable: false,
	    }
	    this.closeModal = this.closeModal.bind(this);
	    this.openModal = this.openModal.bind(this);
	    this.SupportContact=this.SupportContact.bind(this);
	    this.closeModalSecond= this.closeModalSecond.bind(this);
	    this.changeName= this.changeName.bind(this);
	    this.changeEmail= this.changeEmail.bind(this);
	}
	componentWillReceiveProps(nextProps)
    {   
        let checkButtonstatus=nextProps.company.disableaSupportButton;
        this.setState({buttonDisable:checkButtonstatus});
    }
	openModal() {
	    this.setState({modalIsOpen: true});
	}
	closeModal() {
	    this.setState({modalIsOpen: false,userNameReq: false,userMessageReq: false,userEmailReq: false});
	    this.props.resetSupportPopup();
	}
	closeModalSecond(){
	  	this.props.changeMessegeSentStatus();
	  	this.setState({modalIsOpen: false,userNameReq: false,userMessageReq: false,userEmailReq: false});
	}
  	handleToggle = () => this.setState({open: !this.state.open,onLoadMobile:true});
  	// support popup form submit
  	SupportContact(e){
  		e.preventDefault();
  		let name= document.support_contact.name.value;
  		let email= document.support_contact.email.value;
  		let message= document.support_contact.message.value;
  		let useremail=this.props.currentuser.currentUser.email;
  		let companyname=this.props.currentuser.company.name;
  		let companyid= this.props.currentuser.company._id;
  		var validateEmail = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

  		var validation=true;
  		if(name===''){
  			validation=false;
  			this.setState({userNameReq: true});
  			return false;
  		}else{
  			this.setState({userNameReq: false});
  		}

  		if(email==='' || !email.match(validateEmail)){
  			validation=false;
  			this.setState({userEmailReq: true});
  			return false;
  		}else{
  			this.setState({userEmailReq: false});
  		}
  		if(message===''){
  			validation=false;
  			this.setState({userMessageReq: true});
  			return false;
  		}else{
  			this.setState({userMessageReq: false});
  		}
  		if(validation===true){
  			this.setState({buttonDisable:true});
  			this.props.supportContact(name,email,message,companyname,companyid,useremail);
  		}
  	}
  	changeName(e){
  		this.setState({name:e.target.value,changeName:true});
  	}
  	changeEmail(e){
  		this.setState({email:e.target.value,changeEmail:true});
  	}
  	isAdminType(){
	    var usertype = window.localStorage.getItem('userType');
	    let type = this.props.currentuser.loggedInUser.type;
	    if(usertype==='3' && type == 3){
	      return true;
	    }else{
	      return false;
	    }
	  }
    render() {
    	let checkType= this.isAdminType();
    	let userName =  this.props.currentuser.currentUser ? this.props.currentuser.currentUser.name : '';
    	let userEmail = this.props.currentuser.currentUser ? this.props.currentuser.currentUser.email : '';
    	let check=this.props.currentuser.currentUser && this.props.currentuser.currentUser.image && this.props.currentuser.currentUser.image!=='';
    	let $imagePreview=null;
    	var path=apiUrl;
    	if(check){
      		$imagePreview = (<img src={this.props.currentuser.currentUser.image.location} alt="user" />);
    	}else{
      		$imagePreview = (<img src="/images/user-img.jpg" alt="user" />);
    	}
    	const action = [
          <FlatButton
            label="Cancel"
            primary={true}
            onClick={this.closeModal}
          />,
          <RaisedButton
            label="Submit"
            primary={true}
            labelStyle={{'color': '#fff'}}
            keyboardFocused={true}
            onClick={this.SupportContact}
            disabled={this.state.buttonDisable?true:false}
          />,

        ];
        const actionSenDMessage = [
          <RaisedButton
            label="Ok"
            primary={true}
            onClick={this.closeModalSecond}
            labelStyle={{'color': '#fff'}}
          />
        ];
        var checkMobile=false;
		var width = window.innerWidth ;
		if( width<=1080 && this.state.checkOnload==false) {
		 checkMobile=true;
		 this.setState({checkOnload:true,open:false});
		}
        return(<div className="side-bar-dashboard">
            		 <MdMenu onClick={this.handleToggle} onTouchTap={this.handleToggle} className="menu-bar" />
			         <Drawer 
			          docked={false}
			          width={245}
			          containerClassName="side-bar-dokkit"
			          containerStyle={{top:'57px'}}
			           // overlayStyle={{display:'none'}}
			           overlayClassName="side-bar-overlay"
          			  onRequestChange={(open) => this.setState({open})}
			           open={this.state.onLoadMobile || !checkMobile?this.state.open:false}
			          >
			          <div className="side-bar-content">
			          	<div className="user-detail display-flex">
			          		<div className="user-img">
			          			{!checkType?
			          			<Link to="/edit-profile">
			          				{$imagePreview}
			          			</Link>
			          			:
			          			<Link to="#">
			          				{$imagePreview}
			          			</Link> }
			          		</div>
			          		<div className="user-name">
			          			<h3>{userName}</h3>
			          			<p>{userEmail}</p>
			          		</div>
			          	</div>
			          	{!checkType?
			          	<ul className="side-bar-menu">
			          		<li className={this.props.match.url=='/job'?'active':''}>
			          			<Link to="/job">
			          				<MdNextWeek className="icon-sidebar " /> Jobs
			          			</Link>
			          		</li>
			          		<li className={this.props.match.url=='/template'?'active':''}>
			          			<Link to="/template">
			          				<MdInsertDriveFile className="icon-sidebar" /> Templates
			          			</Link>
			          		</li>
			          		<li>
			          			<a href="http://www.dokkit.co.uk/help" target='_blank'>
			          				<MdHelp className="icon-sidebar" /> Help
			          			</a>
			          		</li>
			          	</ul>
			          	:
			          	<ul className="side-bar-menu">
			          		<li className={this.props.match.url=='/job'?'active':''}>
			          			<Link to="/admin-dashboard">
			          				<MdDashboard className="icon-sidebar"/> Dashboard
			          			</Link>
			          		</li>
							<li className={this.props.match.url =='/template'?'active':''}>
			          			<Link to="/admin-template">
			          				<MdInsertDriveFile className="icon-sidebar" /> Templates
			          			</Link>
			          		</li>
			          		<li className={this.props.match.url=='/logs'?'active':''}>
			          			<Link to="/admin-logs">
			          				<MdInsertDriveFile className="icon-sidebar" /> System Logs
			          			</Link>
			          		</li>
			          	</ul> 
			          	}
			          </div>
			          {!checkType?
			          <ul>
			          	<li>
		          			<Link to="#" id="support1" onClick={this.openModal}>
		          				<MdHeadsetMic className="icon-sidebar" /> Support
		          			</Link>
		          		</li>
			          </ul>
			          : null }
			        </Drawer>
			        
			        {(this.props.company.messeageToSupport)?
			        	<Dialog
                          actions={actionSenDMessage}
                          className="model-support"
                          modal={false}
                          contentClassName="model-top-overlay no-overlay"
                          open={ this.state.modalIsOpen || this.props.company.openSubscriptionPopup}
                          onRequestClose={this.closeModal}
                        > 
                    <div className="other-popup-content" style={{'textAlign': 'center'}}>
                        <div className="popup-data" >
                        	<p><span><img src="/images/green.png" height="50" width="50"  alt="imported img" /></span></p>
                        	<p style={{color: '#000'}}>Don't worry we are on it, we will get back to you shortly.</p>
                        </div>
                    </div>
			        </Dialog>
			        :
			        <Dialog
                          actions={action}
                          className="model-support"
                          modal={false}
                          contentClassName="model-top-overlay no-overlay"
                          open={ this.state.modalIsOpen || this.props.company.openSubscriptionPopup }
                          onRequestClose={this.closeModal}
                        > 
                        {this.props.company.isSendingToSupport?
			        	<div className="progressbar">
					         	 <LinearProgress mode="indeterminate" />
			         	</div>
			         	: null }
			        <div className="other-popup-content learn-more-popup">
			        	
			        	<h3>Support</h3>
			        	<h3>Get in touch with us</h3>
                        <p>We will get back to you as soon as we can.</p>
			        	<div className="popup-data">
					        <form name="support_contact" onSubmit={this.SupportContact}>
			                    <Row>
	                                <Col md={6}>
	                                    <TextField
	                                        hintText="Your name"
	                                        fullWidth={ true }
	                                        floatingLabelText="Your name"
	                                        name="name"
	                                        value={userName && !this.state.changeName?userName : this.state.name}
	                                        onClick={this.changeName}
	                                        errorText={this.state.userNameReq?'This field is required':''}
	                                    />
	                                </Col>
	                                <Col md={6}>
	                                    <TextField
	                                        hintText="Your Email Id"
	                                        fullWidth={ true }
	                                        floatingLabelText="Your email"
	                                        type="email"
	                                        name="email"
	                                        value={userEmail && !this.state.changeEmail?userEmail: this.state.email}
	                                        onClick={this.changeEmail}
	                                        errorText={this.state.userEmailReq?'Input a valid email address':''}
	                                    />
	                                </Col>
	                            </Row>
	                            <Row>
	                                <Col md={12}>
	                                    <TextField
	                                        hintText="Write a message"
	                                        fullWidth={ true }
	                                        floatingLabelText="Message"
	                                        type="email"
	                                        name="message"
	                                        multiLine={true}
										    rows={4}
										    rowsMax={6}
	                                        errorText={this.state.userMessageReq?'This field is required':''}
	                                    />
	                                </Col>
	                            </Row>
	                            {this.props.company.isSupportError?
	                            <Row>
	                            	<Col md={12}>
	                                    <div style={{color: 'red'}}>Error Occured during sending email to Support. Please try later</div>
	                                </Col>	
	                            </Row>
	                            : null }
			                </form>
			            </div>
                    </div>
			        </Dialog>
			        }
               </div>
            )
    }
} 

const mapStateToProps= (state,props)=> {
    return {
      currentuser : state.login,
      company: state.company,
    };
}
export default withRouter(connect(mapStateToProps,actions)(SideBar));


// WEBPACK FOOTER //
// ./src/Components/Modules/Helper/SideBar.js